/**
 * @generated SignedSource<<93965499e5ba0fade6bcdf4bf93d2fa8>>
 * @relayHash 5c17b8fbf5a1e69531b46c6e762bc127
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 46a6916f10ae38e187e874e829f804706892021354f2ba5bad26efc50947a5ee

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ui_IssueLinksPopUpContentQuery$variables = {
  cloudId: string;
  issueKey: string;
};
export type ui_IssueLinksPopUpContentQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly issueLinks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly issue: {
              readonly fieldsById: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly statusCategory?: {
                      readonly statusCategoryId: string;
                    };
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly key: string;
              readonly webUrl: AGG$URL | null | undefined;
            } | null | undefined;
            readonly relationName: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ui_IssueLinksPopUpContentQuery = {
  response: ui_IssueLinksPopUpContentQuery$data;
  variables: ui_IssueLinksPopUpContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v4 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = [
  {
    "kind": "Literal",
    "name": "ids",
    "value": [
      "statusCategory"
    ]
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v9 = {
  "kind": "ScalarField",
  "name": "relationName"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_IssueLinksPopUpContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinks",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "concreteType": "JiraIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueLink",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "args": (v7/*: any*/),
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraStatusCategoryField"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                              }
                            ]
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "issueLinks(first:1000)"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ui_IssueLinksPopUpContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinks",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "concreteType": "JiraIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueLink",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "args": (v7/*: any*/),
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  (v10/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraStatusCategoryField"
                                          },
                                          (v10/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                              },
                              (v10/*: any*/)
                            ]
                          },
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "issueLinks(first:1000)"
              },
              (v10/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "46a6916f10ae38e187e874e829f804706892021354f2ba5bad26efc50947a5ee",
    "metadata": {},
    "name": "ui_IssueLinksPopUpContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dab8c0162af3731690c0cb9dc89eb0d4";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
